import {
  Show,
  SimpleShowLayout,
  TextField,
  DateField,
  BooleanField,
} from "react-admin";
export const RolePermissionShow = props => (
  <Show title="Role Permissions Details" {...props}>
    <SimpleShowLayout>
      <TextField source="id" label="Role ID" />
      <TextField source="role_name" label="Role" />
      <TextField source="permissions" />
    </SimpleShowLayout>
  </Show>
);